export type SubscriptionPlan = 'premium_monthly' | 'premium_yearly';

export const isSubscriptionPlan = (value: string): value is SubscriptionPlan => {
  return ['premium_monthly', 'premium_yearly'].includes(value);
};
